import { useState } from "react";
import { useStore } from "../../../helpers";
import { toJS } from "mobx";

const useVoterTableFunctions = () => {
  const { voterListStore } = useStore();
  const { Voterlist } = voterListStore;
  const [columnDefs] = useState([
    {
      headerName: "ID",
      headerClass: "text-xl font-bold",
      children: [
        { headerName: "Slno", field: "slno" },
        { headerName: "Voter ID", field: "voterid" },
      ],
    },
    {
      headerName: "Name & Relation",
      headerClass: "text-xl font-bold",
      children: [
        { headerName: "Name", field: "name" },
        { headerName: "Relation", field: "relation" },
      ],
    },
    {
      headerName: "Personal Information",
      headerClass: "text-xl font-bold",
      children: [
        { headerName: "Is Head of House", field: "hoh" },
        { headerName: "Gender", field: "gender" },
        { headerName: "Age", field: "age" },
        { headerName: "Phone Number", field: "phone" },
      ],
    },
    {
      headerName: "Address & Availability",
      headerClass: "text-xl font-bold",
      children: [
        { headerName: "House", field: "house" },
        { headerName: "City", field: "city" },
        { headerName: "Availability", field: "availability" },
      ],
    },
    {
      headerName: "Booth & Polling Station",
      headerClass: "text-xl font-bold",
      children: [
        { headerName: "Booth Number", field: "booth" },
        { headerName: "Polling Station", field: "pollingStation" },
      ],
    },
  ]);
  const getVoterRows = (voterList) => {
    return toJS(voterList).map((item, index) => {
      return {
        slno: item?.profile?.serialno,
        voterid: item?.profile?.voterid,
        name: item?.profile?.name_eng + " (" + item?.profile?.name_reg + ")",
        relation:
          item?.profile?.relation_name_eng +
          " (" +
          item?.profile?.relation_name_reg +
          ", " +
          item?.profile?.relationship_eng +
          ")",
        hoh: item?.profile?.hoh ? "Yes" : "No",
        gender: item?.profile?.gender || "N/A",
        age: item?.profile?.age || "N/A",
        phone: item?.phone || "N/A",
        house: item?.profile?.house || "N/A",
        city: item?.which_city || "N/A",
        availability: item?.availability || "N/A",
        booth: item?.part || "N/A",
        pollingStation: item?.profile?.poll_eng?.replace(/^_/, "") || "N/A",

        ...item,
      };
    });
  };
  const rowData = getVoterRows(Voterlist);
  const handleRowClick = (voterdata) => {
    voterListStore.update_edit_voter_modal(!voterListStore.edit_voter_modal);
    voterListStore.update_active_voter(voterdata);
  };
  return { columnDefs, rowData, handleRowClick };
};

export default useVoterTableFunctions;
